import { defineSlotRecipe } from '@chakra-ui/react';
import { drawerAnatomy } from '@chakra-ui/react/anatomy';

export const drawerRecipe = defineSlotRecipe({
  slots: drawerAnatomy.keys(),
  className: 'ac-drawer',
  base: {
    backdrop: {
      background: 'rgba(0,0,0, 0.5)',
      insetInlineStart: 0,
      top: 0,
      w: '100vw',
      h: '100dvh',
      position: 'fixed',
      zIndex: 100,

      _open: {
        animationDuration: 'slow',
        animationTimingFunction: 'linear',
        animationName: 'fade-in',
      },
      _closed: {
        animationDuration: 'moderate',
        animationTimingFunction: 'linear',
        animationName: 'fade-out',
      },
    },
    positioner: {
      display: 'flex',
      width: '100vw',
      height: '100dvh',
      position: 'fixed',
      insetInlineStart: 0,
      top: 0,
      zIndex: 100,
      overscrollBehaviorY: 'none',
    },
    content: {
      backgroundColor: 'white',
      overflow: 'hidden',
      maxH: '100dvh',
      // position: 'relative',

      fontFamily: 'acBase',

      _open: {
        animationDuration: 'slowest',
        animationTimingFunction: 'ease-in-smooth',
        animationName: 'slide-from-right-full, fade-in',
      },
      _closed: {
        animationDuration: 'slower',
        animationTimingFunction: 'ease-in-smooth',
        animationName: 'slide-to-right-full, fade-out',
      },
    },
    body: {
      width: '100%',
      height: 'calc(100% - 120px)',
      overflow: 'hidden',
    },
    header: {
      width: '100%',
      height: '120px',
      backgroundColor: 'grey.blue.1',
      borderBottom: '1px solid {colors.grey.light.2}',
      padding: '40px',
      display: 'flex',
      justifyContent: 'space-between',
      flexDir: 'row',
      alignItems: 'center',
    },
    title: {
      color: 'grey.dark.2',
      fontSize: '24px',
      fontWeight: 600,
      lineHeight: '23px',
      letterSpacing: '0.24px',
      margin: 0,
      fontFamily: 'acBase',
    },
  },
  variants: {
    element: {
      hood: {
        body: {
          // padding: '40px',
        },
      },
      spacer: {
        body: {
          // padding: '40px',
        },
      },
      appliance: {
        body: {
          // padding: '40px',
        },
      },
      exhaust: {
        body: {
          // padding: '40px',
        },
      },
      supply: {
        body: {
          // padding: '40px',
        },
      },
      zone: {
        body: {
          // padding: '40px',
        },
      },
      vav: {
        body: {
          // padding: '40px',
        },
      },
      hvac: {
        body: {
          // padding: '40px',
        },
      },
      diffuser: {
        body: {
          // padding: '40px',
        },
      },
      group: {
        body: {
          // padding: '40px',
        },
      },
      room: {
        body: {
          // padding: { base: '40px', lg: '80px 40px 40px' },
        },
      },
      ceiling: {
        body: {
          // padding: '40px',
        },
      },
      wall: {},
    },
    padded: {
      true: {
        body: {
          padding: '40px',
        },
      },
    },
    placement: {
      right: {
        positioner: {
          justifyContent: 'flex-end',
        },
        content: {
          maxWidth: '80vw',
          width: '1200px',
          height: '100%',
          right: 0,
          borderLeftRadius: 'double',
          _open: {
            animationName: 'slide-from-right-full, fade-in',
          },
          _closed: {
            animationName: 'slide-to-right-full, fade-out',
          },
        },
      },
      top: {
        positioner: {
          justifyContent: 'flex-start',
        },
        content: {
          height: '240px',
          width: '100%',
          _open: {
            animationName: 'slide-from-top-full, fade-in',
          },
          _closed: {
            animationName: 'slide-to-top-full, fade-out',
          },
        },
      },
      left: {
        positioner: {
          justifyContent: 'flex-start',
        },
        content: {
          maxWidth: '80vw',
          width: '1200px',
          height: '100%',
          borderRightRadius: 'double',
          left: 0,
          _open: {
            animationName: 'slide-from-left-full, fade-in',
          },
          _closed: {
            animationName: 'slide-to-left-full, fade-out',
          },
        },
      },
    },
    size: {
      wide: {
        content: {
          width: '1200px',
        },
      },
      narrow: {
        content: {
          width: '700px',
        },
      },
    },
  },
  compoundVariants: [
    {
      placement: 'top',
      size: 'wide',
      css: {
        content: {
          width: '100%',
          height: '500px',
        },
      },
    },
    {
      placement: 'top',
      size: 'narrow',
      css: {
        content: {
          width: '100%',
          height: '240px',
        },
      },
    },
  ],
  defaultVariants: {
    placement: 'right',
    size: 'wide',
  },
});
